import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";
import { AddBadge, getAllUserData } from "../../api";
import { useSelector } from "react-redux";
import { BadgeSchema } from "../../schema";

const initialValues = {
  // ProfileDetails
  userId: "",
  color: "",
  // type: "",
  category: "",
  title: "",
};

const AddBadges = () => {
  const { token } = useSelector((state) => state.profileReducer);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState(null);
  const toast = useRef(null);

  const addBadgeHandler = async (values, action) => {
    // const formData = new FormData();
    // formData.append("userId", values?.userId);
    // formData.append("title", values.title);
    // formData.append("color", values.color);
    // formData.append("type", values.type);
    // formData.append("category", values.category);

    await AddBadge(values, token)
      .then((res) => {
        setIsLoading(true);
        toast.current.show({
          severity: "success",
          summary: `${res?.data?.message}`,
        });
        action.resetForm();
        setTimeout(() => {
          setIsLoading(false);
          navigate("/badges");
        }, 1000);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.current.show({
          severity: "error",
          summary: `${err?.response?.data?.message}`,
        });
      });
  };

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    touched,
    // setFieldValue,
    // setFieldTouched,
    handleBlur,
  } = useFormik({
    initialValues,
    validationSchema: BadgeSchema(),
    onSubmit: (values, action) => {
      addBadgeHandler(values, action);
    },
  });

  const getMembers = async () => {
    getAllUserData(token)
      .then((res) => {
        let arr = [];
        res?.data?.result?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.id,
            label: ele?.first_name + " " + ele?.last_name,
          })
        );
        setUsers(arr);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    async function getAllAPI() {
      await getMembers();
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigate = useNavigate();

  return (
    <>
      {isLoading && (
        <div className="set-proper-line-in-all-page">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <Toast ref={toast} />
      <form onSubmit={handleSubmit} className="">
        <div className="back-touserdetails">
          <div className="userprofile-pics">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <svg
                  width="32"
                  height="24"
                  viewBox="0 0 32 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="cursor-pointer"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <path
                    d="M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.93934 10.9393ZM2 13.5H32V10.5H2V13.5Z"
                    fill="black"
                  />
                </svg>
                <h6 className="mb-0">Back to Badges Details</h6>
              </div>
            </div>

            <div className="main-profile-all-cls-start">
              <label className="profile-cls-text mt-4 mb-4">Badges</label>
              <div className="details-all-name upload-user-profile-cls">
                <div className="row">
                  <div className="col-lg-4">
                    <label className="my-2">
                      User<span className="required">*</span>
                    </label>
                    <select
                      name="userId"
                      className="form-select"
                      aria-label="Default select example"
                      placeholder="Select User"
                      onBlur={handleBlur}
                      value={values.userId}
                      onChange={handleChange}
                    >
                      <option value="" disabled hidden>
                        Select User
                      </option>
                      {users &&
                        users.map((ele) => {
                          return (
                            <option key={ele?.id} value={ele?.value}>
                              {ele?.label}
                            </option>
                          );
                        })}
                    </select>
                    {errors.userId && touched.userId ? (
                      <p className="form-error">{errors.userId}</p>
                    ) : null}
                  </div>
                  <div className="col-lg-4">
                    <label className="my-2">
                      Category<span className="required">*</span>
                    </label>
                    <select
                      name="category"
                      className="form-select"
                      value={values.category}
                      aria-label="Default select example"
                      placeholder="Select category"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option value="" disabled hidden>
                        Select category
                      </option>
                      <option value="1" label="Active Member of The Loop">
                        Active Member of The Loop
                      </option>
                      <option
                        value="2"
                        label="The Loop Hall of Fame Excellence Inductee"
                      >
                        The Loop Hall of Fame Excellence Inductee
                      </option>
                      <option
                        value="3"
                        label="The Loop Hall of Fame Gold Inductee"
                      >
                        The Loop Hall of Fame Gold Inductee
                      </option>
                      <option
                        value="4"
                        label="The Loop Hall of Fame Silver Inductee"
                      >
                        The Loop Hall of Fame Silver Inductee
                      </option>
                      <option value="5" label="Super Looper of the Month">
                        Super Looper of the Month
                      </option>
                      <option
                        value="6"
                        label="Most Popular Looper of the Month"
                      >
                        Most Popular Looper of the Month
                      </option>
                      <option value="7" label="Happy Looper Anniversary">
                        Happy Looper Anniversary
                      </option>
                      <option value="8" label="Special Contributor of The Loop">
                        Special Contributor of The Loop
                      </option>
                      <option value="9" label="Scholar Looper">
                        Scholar Looper
                      </option>
                    </select>
                    {errors.category && touched.category ? (
                      <p className="form-error">{errors.category}</p>
                    ) : null}
                  </div>

                  {/* <div className="col-lg-4">
                    <label className="my-2">Type</label>
                    <select
                      name="type"
                      className="form-select"
                      value={values.type}
                      aria-label="Default select example"
                      placeholder="Select Type"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option value="" disabled hidden>
                        Select Type
                      </option>
                      <option value="1" label="Excellence">
                        Excellence
                      </option>
                      <option value="2" label="Silver">
                        Silver
                      </option>
                      <option value="3" label="Gold">
                        Gold
                      </option>
                    </select>
                  </div> */}
                  <div className="col-lg-4">
                    <label className="my-2">
                      Color<span className="required">*</span>
                    </label>
                    <select
                      name="color"
                      className="form-select"
                      value={values.color}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      aria-label="Default select example"
                      placeholder="Select Color"
                    >
                      <option value="" disabled hidden>
                        Select Color
                      </option>
                      <option value="1" label="Magenta">
                        Magenta
                      </option>
                      <option value="2" label="Blue">
                        Blue
                      </option>
                      <option value="3" label="Yellow">
                        Yellow
                      </option>
                      <option value="4" label="Green">
                        Green
                      </option>
                      <option value="5" label="Red">
                        Red
                      </option>
                      <option value="6" label="Grey">
                        Grey
                      </option>
                      <option value="7" label="Orange">
                        Orange
                      </option>
                      <option value="8" label="Pink">
                        Pink
                      </option>
                      <option value="9" label="Purple">
                        Purple
                      </option>
                    </select>
                    {errors.color && touched.color ? (
                      <p className="form-error">{errors.color}</p>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="upload-user-profile-cls">
                <div className="row mt-3">
                  <div className="col-lg-4">
                    <label className="my-2">Title</label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={values.title}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      id="exampleFormControlInput2"
                      placeholder="Enter Your Title Here"
                    />
                    {errors.title && touched.title ? (
                      <p className="form-error">{errors.title}</p>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="upload-user-profile-cls mt-4">
                <div className="right-sidebtn-add text-end">
                  <div className="d-flex align-items-center justify-content-end">
                    <button
                      type="button"
                      className="btn btn-primary outline-btn-cls me-2"
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary filled-btn-cls"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default AddBadges;
